<div class="beta-notice__overlay">
  <div
    class="beta-notice__card"
    role="dialog"
    aria-modal="true"
    aria-labelledby="beta-notice-title"
  >
    <button
      type="button"
      class="beta-notice__close"
      aria-label="Cerrar aviso"
      (click)="onClose()"
    >
      <fa-icon [icon]="faXmark"></fa-icon>
    </button>

    <div class="beta-notice__icon">
      <fa-icon [icon]="faClock"></fa-icon>
    </div>

    <span class="beta-notice__badge">
      <span class="beta-notice__badge-dot"></span>
      AVISO BETA
    </span>

    @if (expired) {
    <h2 class="beta-notice__title" id="beta-notice-title">
      Tu periodo de prueba beta
      <span class="beta-notice__deadline">ya finalizó</span>
    </h2>

    <p class="beta-notice__text">
      No te quedan días de prueba. Tu acceso a ARDIA como beta tester puede
      dejar de estar disponible en cualquier momento. Si deseas conservar tus
      configuraciones, agentes y datos conectados, ponte en contacto con el
      equipo o actualiza tu plan.
    </p>
    } @else {
    <h2 class="beta-notice__title" id="beta-notice-title">
      Tu periodo de prueba beta finaliza
      <span class="beta-notice__deadline">{{ deadlineText }}</span>
    </h2>

    <p class="beta-notice__text">
      Tras ese plazo, tu acceso a ARDIA como beta tester dejará de estar
      disponible. Si deseas conservar tus configuraciones, agentes y datos
      conectados, ponte en contacto con el equipo o actualiza tu plan.
    </p>
    }

    <button type="button" class="beta-notice__action" (click)="onClose()">
      Entendido
    </button>
  </div>
</div>
